import React, {Component} from 'react';
import './GuestlistDetailScreen.css';
import PortalScreen from "../PortalScreen";
import axios from 'axios';
import RmButton from "../../Common/RmButton";
import {Redirect} from "react-router-dom";
import ArrowLink from "../../Common/ArrowLink";
import RmField from "../../Forms/RmField";
import GuestlistCategoryDropdown from "./GuestlistCategoryDropdown";
import RmTextareaField from "../../Forms/RmTextareaField";
import ErrorMessage from "../../Common/ErrorMessage";

export default class GuestlistDetailScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingData: false,
            savingData: false,
            redirectTo: null,
            guest: null,
            errorMessage: null,
            creatingNew: false
        };
    }

    componentDidMount() {
        this.refreshGuest();
    }

    refreshGuest() {
        if (this.state.loadingData) {
            return;
        }

        this.setState({
            loadingData: true
        });

        this.guestId = this.props.match.params.id || "new";
        this.apiUrl = `/guests/${this.guestId}`;

        axios.get(this.apiUrl)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.setState({
                        guest: data.guest,
                        creatingNew: !data.guest.id
                    });
                }
            })
            .catch((err) => {
                console.error('Guest detail GET, error caught:', err);
            })
            .then(() => {
                this.setState({
                    loadingData: false
                });

                if (!this.state.guest) {
                    this.setState({
                        redirectTo: "/gasten"
                    });
                }
            });
    }

    handleDeleteClick() {
        if (this.state.loadingData || this.state.savingData) {
            return;
        }

        this.setState({
            savingData: true,
            errorMessage: null
        });

        axios.delete(this.apiUrl)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.setState({
                        redirectTo: "/gasten"
                    });
                }
            })
            .catch((err) => {
                console.error('Guest detail DELETE, error caught:', err);

                this.setState({
                    errorMessage: "Kon genodigde niet verwijderen"
                });
            })
            .then(() => {
                this.setState({
                    savingData: false
                });
            });
    }

    handleSaveClick(returnAfter) {
        if (this.state.loadingData || this.state.savingData) {
            return;
        }

        this.setState({
            savingData: true,
            errorMessage: null
        });

        let method = "patch";

        if (this.state.creatingNew) {
            method = "post";
        }

        axios[method](this.apiUrl, this.state.guest)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.setState({
                        errorMessage: "De wijzigingen zijn opgeslagen.",
                        creatingNew: false
                    });

                    if (returnAfter) {
                        // Redirect to overview screen after creation
                        this.setState({
                            redirectTo: "/gasten"
                        });
                    } else {
                        // Refresh self after creation
                        if (this.guestId.toString() !== data.guest_id.toString()) {
                            this.setState({
                                redirectTo: `/gasten/${data.guest_id}`
                            });

                            this.setState({
                                redirectTo: null
                            });
                        }
                    }

                    this.guestId = data.guest_id;
                    this.refreshGuest();
                } else {
                    this.setState({
                        errorMessage: data.message || "Er ging iets mis bij het opslaan.",
                    });
                }
            })
            .catch((err) => {
                console.error(`Guest detail ${method.toUpperCase()}, error caught:`, err);

                this.setState({
                    errorMessage: "Kon genodigde niet opslaan."
                });
            })
            .then(() => {
                this.setState({
                    savingData: false
                });
            });
    }

    handleFieldChange(key, value) {
        let nextGuest = this.state.guest;
        nextGuest[key] = value;
        this.setState({guest: nextGuest});
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo}/>;
        }

        let busy = this.state.loadingData || this.state.savingData;
        let screenSubText = "";

        if (this.state.creatingNew) {
            screenSubText = "Gegevens invoeren";
        } else if (this.state.guest) {
            screenSubText = `${this.state.guest.name_first} ${this.state.guest.name_last}`;
        }

        return (
            <PortalScreen tab={"gasten"} title={this.state.creatingNew ? "Genodigde toevoegen" : "Details genodigde"}
                          subText={screenSubText}
                          isLoading={busy}>
                <div className={"GuestlistDetailScreen"}>

                    <div className={"GuestlistScreen__top-controls"}>
                        <ArrowLink label={"Annuleren en terug naar lijst"} routerLink={true} to={"/gasten"}
                                   reverse={true}/>

                        {!this.state.creatingNew &&
                        (
                            <div>
                                <br/>
                                <RmButton label={"Verwijderen van lijst"} onClick={this.handleDeleteClick.bind(this)}
                                          busy={this.state.loadingData || this.state.savingData}/>
                            </div>
                        )}
                    </div>

                    <div className={"GuestlistScreen__hr"}/>

                    {this.state.guest &&
                    <div>
                        <div>
                            <h2 className={"AccountScreen__subtitle"}>Basisgegevens</h2>
                            <RmField id={"name_first"} label={"Voornaam"} iconName={"account-outline"}
                                     disabled={busy} value={this.state.guest.name_first}
                                     onChange={this.handleFieldChange.bind(this, "name_first")}
                            />
                            <RmField id={"name_last"} label={"Achternaam"} iconName={"account-outline"}
                                     disabled={busy} value={this.state.guest.name_last}
                                     onChange={this.handleFieldChange.bind(this, "name_last")}
                            />
                            <GuestlistCategoryDropdown onChange={this.handleFieldChange.bind(this, "category_name")}
                                                       value={this.state.guest.category_name}
                                                       withIcon={true}
                            />
                        </div>
                        <div>
                            <h2 className={"AccountScreen__subtitle"}>Adresgegevens</h2>
                            <RmField id={"address_line"} label={"Adresregel"} iconName={"home"}
                                     disabled={busy} value={this.state.guest.address_line}
                                     onChange={this.handleFieldChange.bind(this, "address_line")}
                            />
                            <RmField id={"address_postcode"} label={"Postcode"} iconName={"home-outline"}
                                     disabled={busy} value={this.state.guest.address_postcode}
                                     onChange={this.handleFieldChange.bind(this, "address_postcode")}
                            />
                            <RmField id={"address_locality"} label={"Plaats"} iconName={"city"}
                                     disabled={busy} value={this.state.guest.address_locality}
                                     onChange={this.handleFieldChange.bind(this, "address_locality")}
                            />
                        </div>
                        <div>
                            <h2 className={"AccountScreen__subtitle"}>Contactgegevens</h2>
                            <RmField id={"phone"} label={"Telefoonnummer"} iconName={"phone"}
                                     disabled={busy} value={this.state.guest.phone}
                                     onChange={this.handleFieldChange.bind(this, "phone")}
                            />
                            <RmField id={"email"} label={"E-mail adres"} iconName={"email"}
                                     disabled={busy} value={this.state.guest.email}
                                     onChange={this.handleFieldChange.bind(this, "email")}
                            />
                        </div>
                        <div>
                            <h2 className={"AccountScreen__subtitle"}>Opties</h2>
                            <RmTextareaField id={"notes"} label={"Notities"} iconName={"pencil"}
                                             disabled={busy} value={this.state.guest.notes}
                                             onChange={this.handleFieldChange.bind(this, "notes")}
                            />
                        </div>
                        <div className={"GuestDetailScreen__controls"}>
                            {this.state.errorMessage &&
                            <ErrorMessage message={this.state.errorMessage}/>
                            }
                            <RmButton label={"Opslaan"} onClick={this.handleSaveClick.bind(this, true)} busy={busy}/>
                        </div>
                    </div>
                    }


                </div>
            </PortalScreen>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Portal/Guestlist/GuestlistDetailScreen.js